export class TableFieldOptions {
    action?: Function
    label?: string
    showPaginator?: boolean;
    showFilter?: boolean;
    key?: string;
    pageIndex?: number;
    pageSize?: number;
    totalItems?: number;
}